<div class="select">
  <label *ngIf="label" [attr.for]="id">{{ label | i18next }}</label>
  <div class="selectwrapper" [ngClass]="{ iconAdjust: isPostcodeResults }">
    <select
      [(ngModel)]="value"
      [ngClass]="{ invalid: hasError }"
      [id]="id"
      [disabled]="disabled"
      (blur)="handleBlur()"
      (click)="handleClick()"
      [ngClass]="{ postcodeResults: isPostcodeResults }"
    >
      <option value="" disabled selected *ngIf="placeholder">
        {{ placeholder | i18next }}
      </option>
      <ng-content></ng-content>
    </select>
  </div>

  <span class="app-error-text" id="errorId" *ngIf="hasError">
    {{ errorText | i18next }}
  </span>
</div>
